import DrillTopicRenderer from '~/components/Drill/DrillTopic/components/DrillTopicRenderer'
import MessageBox from '~/components/Drill/DrillTopic/components/MessageBox'
import TopicMetatags from '~/components/Metadata/TopicMetatags'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { DrillTopicOverview } from '~/types/theory'
import { BackButton } from '~/components/Buttons/BackButton'

export default function DrillTopic({ topic }: { topic: DrillTopicOverview }): React.ReactElement {
  const { h1, breadcrumbs } = topic
  const backButtonIndex = breadcrumbs.length - 2

  return (
    <>
      <TopicMetatags topic={topic} />
      <DefaultLayout>
        <BackButton href={breadcrumbs[backButtonIndex].path} pageTitle={breadcrumbs[backButtonIndex].h1} />

        <div className="max-w-5xl mx-auto pb-8 space-y-16 xl:space-y-10">
          <MessageBox breadcrumbs={breadcrumbs} h1={h1} />
          <DrillTopicRenderer topic={topic} />
        </div>
      </DefaultLayout>
    </>
  )
}
